import { format } from "d3-format";
export function formatCoordForZoomLevel(val, zoom) {
  if (zoom < 2) {
    return fmt1(val);
  } else if (zoom < 4) {
    return fmt2(val);
  } else if (zoom < 7) {
    return fmt3(val);
  }

  return fmt4(val);
}
export function joinURL() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var newURL = args[0];

  for (var i = 1; i < args.length; i++) {
    newURL = newURL.replace(/\/$/, "") + "/" + args[i].replace(/^\//, "");
  }

  return newURL;
}
export var fmt4 = format(".4~f");
export var fmt3 = format(".3~f");
export var fmt2 = format(".2~f");
export var fmt1 = format(".1~f");
export var fmtInt = format(".0f");